const plainPages = ['/signin', '/signup', '/forgot-password', /^\/reset-password\/.*\/.*/, /^\/verify-account\/.*\/.*/];

export { plainPages };
